module.exports = __webpack_public_path__ + "img/support 1.e1e89fae.png";